import { Component } from '@angular/core';
// import type { OnInit } from '@angular/core';
import { MenuController, IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
    'selector': 'app-dashboard',
    'templateUrl': './dashboard.page.html',
    'styleUrls': ['./dashboard.page.scss'],
    'standalone': true,
    'imports': [IonicModule, CommonModule, FormsModule]
})
export class DashboardPage {
    constructor(private menuController: MenuController) { }

    // public ngOnInit() {}

    public onOpenSidemenuClick() {
        this.menuController.enable(true, 'sideMenu');
        this.menuController.open('sideMenu');
    }

    public onCloseSidemenuClick() {
        this.menuController.close('sideMenu');
    }
}
